import gql from "graphql-tag";

export const NOTICE_DEALERSHIP_PARTS_JOB = gql`
  mutation noticeDealershipPartsJob($jobId: ID!) {
    noticeDealershipPartsJob(jobId: $jobId) {
      id
      actor
      objectId
      objectType
      createdAt
      verb
    }
  }
`;
